export default {
    data() {
        return {
            valid: {
                friendly_name: false,
                cash_register_code: false,
            },
            success: {
                friendly_name: false,
                cash_register_code: false,
            },
            error: {
                friendly_name: "",
                cash_register_code: "",
            },
            errorMessages: {
                friendlyNameRequired: {
                    el: "Απαιτείται ένα φιλικό όνομα.",
                    en: "A friendly name is required.",
                    it: "È richiesto un nome amichevole."
                },
                codeRequired: {
                    el: "Απαιτείται ο κωδικός της ταμειακής μηχανής.",
                    en: "The cash register's code is required.",
                    it: "Il codice del registratore di cassa è necessario."
                },
            }
        };
    },

    computed: {
        formValid() {
            return (
                this.valid.friendly_name &&
                this.valid.cash_register_code
            );
        }
    },

    methods: {
        validateFriendlyName() {
            if (!this.item.friendly_name) {
                this.error.friendly_name = this.errorMessages.friendlyNameRequired[
                    this.lang
                ];
            } else {
                this.error.friendly_name = "";
            }
        },

        validateCode() {
            if (!this.item.cash_register_code) {
                this.error.cash_register_code = this.errorMessages.codeRequired[
                    this.lang
                ];
            } else {
                this.error.newPassword = "";
            }
        },

    },

    watch: {
        ["item.friendly_name"]: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.valid.friendly_name = true;
                    this.success.friendly_name = true;
                } else {
                    this.valid.friendly_name = false;
                    this.success.friendly_name = false;
                }
            }
        },
        ["item.cash_register_code"]: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.valid.cash_register_code = true;
                    this.success.cash_register_code = true;
                } else {
                    this.valid.cash_register_code = false;
                    this.success.cash_register_code = false;
                }
            }
        },

        resetSuccess(val) {
            if (val) {
                this.success = {
                    friendly_name: false,
                    cash_register_code: false,
                };

                this.setResetSuccess({ value: false, type: "cashRegisters" });
            }
        }
    }
};
